import { render, staticRenderFns } from "./Brosmind.vue?vue&type=template&id=f6e7ea7e&scoped=true&"
import script from "./Brosmind.vue?vue&type=script&lang=js&"
export * from "./Brosmind.vue?vue&type=script&lang=js&"
import style0 from "./Brosmind.vue?vue&type=style&index=0&id=f6e7ea7e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6e7ea7e",
  null
  
)

export default component.exports